<!-- <ng-container *ngFor="let a of agenda; let i = index">
    <div class="top-container" (click)="hide = !hide">
        <h4 class="m-0">{{ addDays(obtenerFechasLunesADomingo().lunes, i) }}</h4>
        <i class="pi pi-angle-down" style="font-size: 1.2rem"></i>
    </div> -->
<div [ngClass]="{ 'hide': hide }" class="pl-3 mt-2 show">
    <div>
        <ng-container *ngIf="item ? item.length > 0 : false; else noData">
            <div class="content-container pl-2" *ngFor="let i of item" style="border-left: solid {{i.color}} 4px;">
                <div class="top-container">
                    <p class="m-0 mr-3"><b>{{ i.titulo }} - Hora {{ i.inicio | date: 'HH:mm' }}</b></p>
                    <p class="m-0"><small>{{ i.id_lob ? '(Act. general)' : '(Act. personal)' }}</small></p>
                </div>
                <p class="m-0">{{ i.descripcion }}</p>
            </div>
        </ng-container>
        <ng-template #noData>
            <p>No hay actividades registradas</p>
        </ng-template>
    </div>
</div>
<hr>
<!-- </ng-container> -->